import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { http, formatApiError } from "@/lib/api";
import { CheckCircle, Hourglass } from "@phosphor-icons/react";

export default function PaymentSuccessPage() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const taskId = params.get("task_id");
    const [status, setStatus] = useState("polling");
    const [error, setError] = useState("");
    const [attempts, setAttempts] = useState(0);

    useEffect(() => {
        if (!sessionId) { setStatus("error"); setError("Missing session_id"); return; }

        let cancelled = false;
        let n = 0;

        async function poll() {
            if (cancelled) return;
            if (n >= 10) { setStatus("timeout"); return; }
            n += 1; setAttempts(n);
            try {
                const { data } = await http.get(`/payments/status/${sessionId}`);
                if (data.payment_status === "paid") { setStatus("paid"); return; }
                if (data.payment_status === "expired") { setStatus("expired"); return; }
                setTimeout(poll, 2000);
            } catch (e) { setError(formatApiError(e)); setTimeout(poll, 2500); }
        }
        poll();
        return () => { cancelled = true; };
    }, [sessionId]);

    return (
        <div data-testid="payment-success-page" className="max-w-2xl mx-auto px-6 py-24 text-center">
            {status === "paid" ? (
                <>
                    <CheckCircle size={80} weight="duotone" className="text-gold mx-auto" />
                    <h1 className="font-serif text-5xl mt-6">Thank you.</h1>
                    <p className="text-slate-400 mt-4">Your payment has been received. Your Butler will be in touch shortly.</p>
                </>
            ) : status === "timeout" || status === "expired" ? (
                <>
                    <h1 className="font-serif text-4xl">Payment status pending</h1>
                    <p className="text-slate-400 mt-4">{error || "We couldn't confirm payment in time. Please check your task page."}</p>
                </>
            ) : (
                <>
                    <Hourglass size={64} weight="duotone" className="text-gold mx-auto animate-pulse" />
                    <h1 className="font-serif text-4xl mt-6">Confirming your payment…</h1>
                    <p className="text-slate-500 mt-3 text-sm">Attempt {attempts}/10</p>
                </>
            )}
            <div className="mt-10 flex gap-3 justify-center">
                {taskId && <Link to={`/tasks/${taskId}`} className="btn-ghost">View task</Link>}
                <Link to="/dashboard" className="btn-gold">My tasks</Link>
            </div>
        </div>
    );
}
